"use strict";
function escapeRegexp(queryToEscape) {
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}
exports.escapeRegexp = escapeRegexp;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/ng2-select/select/common.js
// module id = ../../../../ng2-select/select/common.js
// module chunks = 5